import React, { useEffect } from 'react';
import Hero from '../../components/sections/Hero';
import Overview from '../../components/sections/Overview';
import Services from '../../components/sections/Services';
import Process from '../../components/sections/Process';
import Technologies from '../../components/sections/Technologies';
import Cta from '../../components/sections/Cta';
import { setupScrollAnimations } from '../../utils/animations';
import { dataEngineeringPageData } from '../../data/dataEngineeringPageData';

const DataEngineeringPage = () => {
  useEffect(() => {
    const observer = setupScrollAnimations();
    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <Hero
        variant="biHero"
        title={dataEngineeringPageData.hero.title}
        description={dataEngineeringPageData.hero.description}
      />
      <Overview data={dataEngineeringPageData.overview} />
      <Services data={dataEngineeringPageData.services} />
      <Process data={dataEngineeringPageData.process} />
      <Technologies data={dataEngineeringPageData.technologies} />
      <Cta data={dataEngineeringPageData.cta} />
    </div>
  );
};

export default DataEngineeringPage;
